import { render } from "./qzjdetail.vue?vue&type=template&id=9baa08c0&scoped=true&ts=true"
import script from "./qzjdetail.vue?vue&type=script&lang=ts"
export * from "./qzjdetail.vue?vue&type=script&lang=ts"

import "./qzjdetail.vue?vue&type=style&index=0&id=9baa08c0&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9baa08c0"]])

export default __exports__